var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtrlC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 2.78V11.3333C1.39986 12.1796 1.73773 12.9943 2.34506 13.6121C2.95239 14.2298 3.78371 14.6045 4.6704 14.66L4.9 14.6667H11.0796C10.9349 15.0566 10.6668 15.3941 10.3123 15.6329C9.95774 15.8717 9.53422 15.9999 9.1 16H4.2C3.08609 16 2.0178 15.5786 1.23015 14.8284C0.442499 14.0783 2.88731e-07 13.0609 2.88731e-07 12V4.66667C-0.000227472 4.2529 0.134299 3.84925 0.385039 3.51135C0.63578 3.17344 0.990391 2.91792 1.4 2.78ZM11.9 0C12.457 0 12.9911 0.210714 13.3849 0.585787C13.7788 0.960859 14 1.46957 14 2V11.3333C14 11.8638 13.7788 12.3725 13.3849 12.7475C12.9911 13.1226 12.457 13.3333 11.9 13.3333H4.9C4.34305 13.3333 3.8089 13.1226 3.41508 12.7475C3.02125 12.3725 2.8 11.8638 2.8 11.3333V2C2.8 1.46957 3.02125 0.960859 3.41508 0.585787C3.8089 0.210714 4.34305 0 4.9 0H11.9Z",
    fill: "#FF7925"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtrlC);
export default __webpack_public_path__ + "static/media/ctrl-c.e1c46948efb10ded8f80e21b9643d8f5.svg";
export { ForwardRef as ReactComponent };